import { deepClone } from "../../utils/global_functions";
import { ORDERS } from "../actionTypes";

// Vinit Raut : 12-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- Start
const intitialOrderTypesState = [
    { id: 1, title: 'Single Scrip', data: [], metadata: [] },
    { id: 2, title: 'Multi Scrip', data: [], metadata: [] },
    { id: 3, title: 'Equity Sip', data: [], metadata: [] },
    { id: 4, title: 'Good Till Trigger', data: [], metadata: [] },// BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025
    { id: 5, title: 'Spread', data: [], metadata: [] }
];
// Vinit Raut : 12-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- End

const initialState = {
    scripOrderInfo: {},
    activeOrders: [],
    arrMarginInfo: null,
    allOrders: [],
    getSipOrder: [],
    sipOrder: {},
    updateSip: {},
    cancelSip: {},
    // brokerageCharges: [],
    arrScripExchanges: [],
    productTypes: [],
    // Vinit Raut : 12-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- Start   */}
    orderTypes: intitialOrderTypesState,
    //  Vinit Raut : 12-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- End   */}
    orderTrades: [],
    sipSettingDetails: {},
    orderHistory: [],
    singleScripOrder: {},
    multiScriptSecondLeg: {},
    placeMultilegOrder: [],
    spreadOrderInfo: [],
    orderCart: {},
    placeOrderCart: {},
    getFrequency: { monthly: 'MONTHLY', forthnightly: 'FORTHNIGHTLY', weekly: 'WEEKLY', daily: 'DAILY' },
    orderInfo: {},
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
    getMultiScripOrder: {},
    getMultiLegOrder: {},
    getSpreadOrder: {},
    orderMarginParams: [],
    ltpPriceBandMaster: null,
    marketStatus: [],
    bannedScripStatus: [],
    bannedScripsList: [],
    isLoadingMarginInfo: false,
    isSingleScripOrderConfirmed: false,
    // Parshva Shah :03/11/2023 : BT-114196 - Breeze - LTP based Price band Implementation - Start
    isMultiLegOrderConfirmed: false,
    isSpreadOrderConfirmed: false,
    // Parshva Shah :03/11/2023 : BT-114196 - Breeze - LTP based Price band Implementation - End
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End
    //Ameersha N:25-08-2023 : BT-107070 -Breeze - Scrip Spread Order entry -Start
    multiSpreadOrderInfo: {},
    //Ameersha N:25-08-2023 : BT-107070 -Breeze - Scrip Spread Order entry - End
    multiLegData: [],
    multiLegDataForBrokerage: [],
    gtdOrders: [],
    //Maaz A : 20-10-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
    gtdOpenOrders: [],
    gtdCompletedOrders: [],
    //Maaz A : 20-10-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
    //Ameersha N: 7-09-2023 : BT-96552 - Breeze - Manage Columns -Start
    singleScripColdef: [],
    multiLegColdef: [],
    equitySipColdef: [],
    spreadOrderColdef: [],
    gtdColdef: [],
    //Ameersha N: 7-09-2023 : BT-96552 - Breeze - Manage Columns -End
    arrCompletedOrders: [],
    arrOpenOrders: [],
    arrSingleOrderColumnDefs: [],
    arrMultiLegOrderColumnDefs: [],
    arrSpreadOrderColumnDefs: [],
    // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
    arrSipEquityOrderColumnDefs: [],
    // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End
    //Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
    nAllSingleScripOrdersLength: 0,
    nOpenSingleScripOrdersLength: 0,
    nCompletedSingleScripOrdersLength: 0,
    //Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
    // Azeem K : 20-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
    arrAllSipOrders: [],
    arrOpenSipOrders: [],
    arrCompletedSipOrders: [],
    nCurrentPage: 1,
    bIsOrderApiPending: false,
    bIsOrderEntryApiPending: false,
    // Azeem K : 20-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End

    isResetScrip: false, //Ameersha N : 08-01-2024 : BT-102298 - Breeze - Single Scrip Order entry - Resetign scrip scrplot and trigger when a search scrip is selected
    objFilterData: {},//Vaibhav Singh: 05-02-24: BT-104814: Added filter object
    bIsMultipleOrdersCancelinProcess: false,  //Azeem K : 06-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - All segments

    buy_or_sell: '',

    arrSpreadAllOrders: [],
    arrSpreadOpenOrders: [],
    arrSpreadCompletedOrders: [],
    nAllSpreadOrdersLength: 0,
    nOpenSpreadOrdersLength: 0,
    nCompletedSpreadOrdersLength: 0,
    spreadLoader: false, // Ajitesh 15-07-2024 Spread loader for pagination

    // Ajitesh 12-07-2024 State for multileg pagination start
    arrMultilegAllOrders: [],
    arrMultilegOpenOrders: [],
    arrMultilegCompletedOrders: [],
    nAllMultilegOrdersLength: 0,
    nOpenMultilegOrdersLength: 0,
    nCompletedMultilegOrdersLength: 0,
    multilegLoader: false,
    // Ajitesh 12-07-2024 State for multileg pagination end
    spreadSideOrderStatus: false,
    bIsShowSideTrayPlaceOrder: true,
    bIsShowSideTrayOrderConfirmation: false,
    bIsShowSideTrayOrderStatus: false,
    objEquitySIPMetaData: {}, // storing equity SIP orders count
    arrSlicedRequestData: [],//BREEZE-16 : Order Slicing Feature : ManasaB : 22-11-2024 : Placing Order for Squareoff issue
    objGTDMetaData: {},
    multiScripActiveTab: 'futures',
    objEqSIPScripMaster: {},
    objExitOrderData: {},//  Azeem K : 15-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order,
    objSpreadInfoBrokerage: {},
    objSideTrayKeys: {},
    /* BREEZE-9316: Margin Shortfall: Ravi R: 11-07-2025: Shortfall amount: Start */
    shortfallAmount: { shortfallAmount: 0 },
    nHorizontalScripPrice: 0,
    /* BREEZE-9316: Margin Shortfall: Ravi R: 11-07-2025: Shortfall amount: End */
    bIsSideTrayOrderApiPending: false
};

const ordersReducer = (state = initialState, actions) => {

    switch (actions.type) {
        case ORDERS.UPDATE_SPREAD_INFO_FOR_BROKERAGE:
            return {
                ...state,
                objSpreadInfoBrokerage: actions?.payload
            };
        case ORDERS?.UPDATE_MULTILEG_ADD_LEG_MODAL_ACTIVE_TAB:
            return {
                ...state,
                multiScripActiveTab: actions?.payload
            };
        //Ameersha N : 11-03-2024 : BT-107070 - Breeze - Spread Order entry - Start
        case ORDERS?.UPDATE_BUY_SELL:
            return {
                ...state,
                buy_or_sell: actions?.payload
            };
        //Ameersha N : 11-03-2024 : BT-107070 - Breeze - Spread Order entry - End

        //Ameersha N : 08-01-2024 : BT-102298 - Breeze - Single Scrip Order entry - Resetign scrip scrplot and trigger when a search scrip is selected - Start
        case ORDERS?.UPDATE_RESET_SCRIP:
            return {
                ...state,
                isResetScrip: actions?.payload
            };
        //Ameersha N : 08-01-2024 : BT-102298 - Breeze - Single Scrip Order entry - Resetign scrip scrplot and trigger when a search scrip is selected - End
        case ORDERS?.UPDATE_ORDER_SINGLE_SCRIP_COL_DEF:
            return { ...state, singleScripColdef: actions?.payload };
        case ORDERS?.UPDATE_GTD_COL_DEF:
            {
                return { ...state, gtdColdef: actions?.payload };
            }

        case ORDERS?.UPDATE_MULTI_LEG_COL_DEF:
            return { ...state, multiLegColdef: actions?.payload };
        case ORDERS?.UPDATE_EQUITY_SEIP_COL_DEF:
            return { ...state, equitySipColdef: actions?.payload };
        case ORDERS?.UPDATE_SPREAD_COL_DEF:
            return { ...state, spreadOrderColdef: actions?.payload };

        case ORDERS?.UPDATE_SPREAD_ORDER_INFO:
            return {
                ...state,
                multiSpreadOrderInfo: actions?.payload
            };
        case ORDERS.UPDATE_ALL_ORDERS:
            return {
                ...state,
                allOrders: actions.payload,
            };
        case ORDERS.GET_SCRIP_ORDER_INFO:
            return {
                ...state,
                scripOrderInfo: actions.payload
            };
        case ORDERS.UPDATE_ACTIVE_ORDERS:
            return {
                ...state,
                activeOrders: actions.payload,

            };
        case ORDERS.PLACE_SINGLESCRIP_ORDER_SUCCESS:
            return {
                ...state,
                singleScripOrder: actions.payload
            };
        case ORDERS.PLACE_SINGLESCRIP_ORDER_FAILURE:
            return {
                ...state,
                singleScripOrder: actions.payload
            };

        case ORDERS.PLACE_SIP_ORDER_SUCCESS:
            return {
                ...state,
                sipOrder: actions.payload
            };
        case ORDERS.PLACE_SIP_ORDER_FAILURE:
            return {
                ...state,
                sipOrder: actions.payload
            };
        // case ORDERS.GET_ALL_SIP_ORDERS_SUCCESS:
        //     return {
        //         ...state,
        //         getSipOrder: actions.payload,

        //     };
        // case ORDERS.GET_ALL_SIP_ORDERS_FAILURE:
        //     return {
        //         ...state,
        //         getSipOrder: actions.payload
        //     };

        case ORDERS.UPDATE_SIP_ORDER_SUCCESS:
            return {
                ...state,
                updateSip: actions.payload
            };

        case ORDERS.UPDATE_SIP_ORDER_FAILURE:
            return {
                ...state,
                updateSip: actions.payload
            };
        case ORDERS.CANCEL_SIP_ORDER_SUCCESS:
            return {
                ...state,
                cancelSip: actions.payload
            };
        case ORDERS.CANCEL_SIP_ORDER_FAILURE:
            return {
                ...state,
                cancelSip: actions.payload
            };


        case ORDERS.GET_SIP_SETTING_DETAILS_SUCCESS:
            return {
                ...state,
                sipSettingDetails: actions.payload
            };
        case ORDERS.GET_SIP_SETTING_DETAILS_FAILURE:
            return {
                ...state,
                sipSettingDetails: actions.payload
            };

        case ORDERS.GET_SIP_ORDER_HISTORY_SUCCESS:
            return {
                ...state,
                orderHistory: actions.payload
            };
        case ORDERS.GET_SIP_ORDER_HISTORY_FAILURE:
            return {
                ...state,
                orderHistory: actions.payload
            };
        case ORDERS.UPDATE_IS_LOADING_ORDER_MARGIN_INFO:
            return {
                ...state,
                isLoadingMarginInfo: actions.payload

            };
        case ORDERS.GET_ORDER_MARGIN_INFO_SUCCESS:
            return {
                ...state,
                arrMarginInfo: actions.payload

            };
        case ORDERS.GET_HORIZONTAL_SCRIP_PRICE:
            return {
                ...state,
                nHorizontalScripPrice: actions.payload

            };
        case ORDERS.GET_ORDER_MARGIN_INFO_FAILURE:
            return {
                ...state,
                arrMarginInfo: actions.payload
            };

        case ORDERS.GET_EXCHANGE_WISE_SCRIP_INFO_SUCCESS: {
            return {
                ...state,
                arrScripExchanges: actions.payload
            };
        }

        case ORDERS.GET_EXCHANGE_WISE_SCRIP_INFO_FAILURE: {
            return {
                ...state,
                arrScripExchanges: actions.payload
            };
        }

        case ORDERS.GET_DYNAMIC_PRODUCT_TYPES_SUCCESS: {
            return {
                ...state,
                productTypes: actions.payload
            };
        }

        case ORDERS.GET_DYNAMIC_PRODUCT_TYPES_FAILURE: {
            return {
                ...state,
                productTypes: actions.payload
            };
        }

        case ORDERS.GET_ORDER_TRADES:
            return {
                ...state,
                orderTrades: actions.payload
            };
        case ORDERS.GET_MUITISCRIPT_SECONDLEG_SUCCESS: {
            return {
                ...state,
                multiScriptSecondLeg: actions.payload
            };
        }

        case ORDERS.GET_MUITISCRIPT_SECONDLEG_FAILURE: {
            return {
                ...state,
                multiScriptSecondLeg: actions.payload
            };
        }
        case ORDERS.GET_PLACE_MULTILEG_ORDER_SUCESS: {
            return {
                ...state,
                placeMultilegOrder: actions.payload
            };
        }

        case ORDERS.GET_PLACE_MULTILEG_ORDER_FAILURE: {
            return {
                ...state,
                placeMultilegOrder: actions.payload
            };
        }
        case ORDERS.GET_SPREAD_ORDER_SUCESS: {
            return {
                ...state,
                spreadOrderInfo: actions.payload
            };
        }

        case ORDERS.GET_SPREAD_ORDER_FAILURE: {
            return {
                ...state,
                spreadOrderInfo: []
            };
        }
        case ORDERS.HANDLE_SPREAD_SIDE_ORDER: {
            return {
                ...state,
                spreadSideOrderStatus: actions.payload
            };
        }
        case ORDERS.ORDERCART_MULTISCRIPT_SUCCESS:
            return {
                ...state,
                orderCart: actions.payload
            };
        case ORDERS.ORDERCART_MULTISCRIPT_SUCCESS_FAILURE:
            return {
                ...state,
                orderCart: actions.payload
            };
        case ORDERS.PLACE_MULTISCRIPT_ORDERCART_SUCCESS:
            return {
                ...state,
                placeOrderCart: actions.payload
            };
        case ORDERS.PLACE_MULTISCRIPT_ORDERCART_FAILURE:
            return {
                ...state,
                placeOrderCart: actions.payload
            };
        case ORDERS.MULTILEG_DATA_FOR_BROKERAGE:
            return {
                ...state,
                multiLegDataForBrokerage: actions?.payload
            };
        case ORDERS.MULTI_LEG_DATA:
            return {
                ...state,
                multiLegData: actions.payload,
            };
        case ORDERS.GET_SIP_ORDER_FREQUENCY: {
            return {
                ...state,
                getFrequency: actions.payload
            };
        }
        case ORDERS.GET_ORDER_INFO: {
            return {
                ...state,
                orderInfo: actions.payload
            };
        }
        case ORDERS.GET_ALL_MULTI_SCRIP_ORDER_SUCCESS:
            return {
                ...state,
                getMultiScripOrder: actions.payload,

            };
        case ORDERS.GET_ALL_MULTI_SCRIP_ORDER_FAILURE:
            return {
                ...state,
                getMultiScripOrder: actions.payload
            };
        case ORDERS.GET_ALL_MULTI_LEG_ORDER_SUCCESS:
            return {
                ...state,
                getMultiLegOrder: actions.payload,
            };
        case ORDERS.GET_ALL_MULTI_LEG_ORDER_FAILURE:
            return {
                ...state,
                getMultiLegOrder: actions.payload
            };
        case ORDERS.GET_ALL_SPREAD_ORDER_SUCCESS:
            return {
                ...state,
                getSpreadOrder: actions.payload,
            };
        case ORDERS.GET_ALL_SPREAD_ORDER_FAILURE:
            return {
                ...state,
                getSpreadOrder: actions.payload
            };
        case ORDERS.GET_ALL_GTD_ORDER_SUCCESS:
            return {
                ...state,
                gtdOrders: actions.payload,

            };
        case ORDERS.GET_OPEN_GTD_ORDER:
            return {
                ...state,
                gtdOpenOrders: actions.payload,

            };
        case ORDERS.GET_COMPLETED_GTD_ORDER:
            return {
                ...state,
                gtdCompletedOrders: actions.payload,

            };
        //Maaz A : 20-10-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
        case ORDERS.UPDATE_ALL_GTD_ORDER_SUCCESS:
            return {
                ...state,
                gtdOrders: [...state?.gtdOrders, ...actions.payload],

            };
        case ORDERS.UPDATE_OPEN_GTD_ORDER:
            return {
                ...state,
                gtdOpenOrders: [...state?.gtdOpenOrders, ...actions.payload],

            };
        case ORDERS.UPDATE_COMPLETED_GTD_ORDER:
            return {
                ...state,
                gtdCompletedOrders: [...state?.gtdCompletedOrders, ...actions.payload],

            };
        //Maaz A : 20-10-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
        case ORDERS.GET_ALL_OPEN_ORDER_SUCCESS:
            return {
                ...state,
                orderTypes: actions.payload
            };

        case ORDERS.GET_ALL_OPEN_ORDER_FAILURE:
            return {
                ...state,
                orderTypes: actions.payload
            };

        // Vinit Raut : 23-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- Start
        case ORDERS.CLEAR_ALL_OPEN_ORDERS:
            const initialOpenOrdersState = deepClone(intitialOrderTypesState);
            return {
                ...state,
                orderTypes: initialOpenOrdersState
            };
        // Vinit Raut : 23-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- End

        //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
        case ORDERS.GET_MARGIN_PLUS_PARAMS_SUCCESS:
            return {
                ...state,
                orderMarginParams: actions.payload
            };
        case ORDERS.GET_MARGIN_PLUS_PARAMS_FAILURE:
            return {
                ...state,
                orderMarginParams: actions.payload
            };
        case ORDERS.GET_LTP_PRICE_BAND_SUCCESS:
            return {
                ...state,
                ltpPriceBandMaster: actions.payload
            };
        case ORDERS.GET_LTP_PRICE_BAND_FAILURE:
            return {
                ...state,
                ltpPriceBandMaster: actions.payload
            };
        case ORDERS.GET_BANNED_SCRIP_STATUS_SUCCESS:
            return {
                ...state,
                bannedScripStatus: actions.payload
            };
        case ORDERS.GET_BANNED_SCRIP_STATUS_FAILURE:
            return {
                ...state,
                bannedScripStatus: actions.payload
            };
        case ORDERS.GET_BANNED_SCRIP_LIST_SUCCESS:
            return {
                ...state,
                bannedScripsList: actions.payload
            };
        case ORDERS.GET_BANNED_SCRIP_LIST_FAILURE:
            return {
                ...state,
                bannedScripsList: actions.payload
            };
        case ORDERS.GET_MARKET_STATUS_SUCCESS:
            return {
                ...state,
                marketStatus: actions.payload
            };
        case ORDERS.GET_MARKET_STATUS_FAILURE:
            return {
                ...state,
                marketStatus: actions.payload
            };
        case ORDERS.UPDATE_SINGLE_SCRIP_IS_ORDER_CONFIRMED:
            return {
                ...state,
                isSingleScripOrderConfirmed: actions.payload
            };
        //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End
        // Parshva Shah :03/11/2023 : BT-114196 - Breeze - LTP based Price band Implementation - Start
        case ORDERS.UPDATE_MULTI_LEG_IS_ORDER_CONFIRMED:
            return {
                ...state,
                isMultiLegOrderConfirmed: actions.payload
            };
        case ORDERS.UPDATE_SPREAD_IS_ORDER_CONFIRMED:
            return {
                ...state,
                isSpreadOrderConfirmed: actions.payload
            };
        // Parshva Shah :03/11/2023 : BT-114196 - Breeze - LTP based Price band Implementation - End
        case ORDERS.GET_COMPLETED_ORDERS_SUCCESS:
            return {
                ...state,
                arrCompletedOrders: actions.payload
            };
        case ORDERS.GET_COMPLETED_ORDERS_FAILURE:
            return {
                ...state,
                arrCompletedOrders: actions.payload
            };
        case ORDERS.GET_OPEN_ORDERS_SUCCESS:
            return {
                ...state,
                arrOpenOrders: actions.payload
            };
        case ORDERS.GET_OPEN_ORDERS_FAILURE:
            return {
                ...state,
                arrOpenOrders: actions.payload
            };
        case ORDERS.GET_SINGLE_SCRIP_ORDER_COLUMNDEFS_SUCCESS:
            return {
                ...state,
                arrSingleOrderColumnDefs: actions.payload
            };
        case ORDERS.GET_SINGLE_SCRIP_ORDER_COLUMNDEFS_FAILURE:
            return {
                ...state,
                arrSingleOrderColumnDefs: actions.payload
            };
        case ORDERS.GET_MULTI_LEG_ORDER_COLUMNDEFS_SUCCESS:
            return {
                ...state,
                arrMultiLegOrderColumnDefs: actions.payload
            };
        case ORDERS.GET_MULTI_LEG_ORDER_COLUMNDEFS_FAILURE:
            return {
                ...state,
                arrMultiLegOrderColumnDefs: actions.payload
            };
        case ORDERS.GET_SPREAD_ORDER_COLUMNDEFS_SUCCESS:
            return {
                ...state,
                arrSpreadOrderColumnDefs: actions.payload
            };
        case ORDERS.GET_SPREAD_ORDER_COLUMNDEFS_FAILURE:
            return {
                ...state,
                arrSpreadOrderColumnDefs: actions.payload
            };
        // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
        case ORDERS.GET_SIP_EQUITY_ORDERBOOK_COLUMNS_SUCCESS:
            return {
                ...state,
                arrSipEquityOrderColumnDefs: actions.payload
            };
        case ORDERS.GET_SIP_EQUITY_ORDERBOOK_COLUMNS_FAILURE:
            return {
                ...state,
                arrSipEquityOrderColumnDefs: actions.payload
            };
        // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End
        //Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
        case ORDERS.UPDATE_SINGLE_ALL_ORDERS:
            return {
                ...state,
                allOrders: [...state?.allOrders, ...actions.payload]
            };
        case ORDERS.UPDATE_SINGLE_OPEN_ORDERS:
            return {
                ...state,
                arrOpenOrders: [...state?.arrOpenOrders, ...actions.payload]
            };
        case ORDERS.UPDATE_SINGLE_COMPLETED_ORDERS:
            return {
                ...state,
                arrCompletedOrders: [...state?.arrCompletedOrders, ...actions.payload]
            };
        case ORDERS.GET_ALL_SINGLE_SCRIP_ORDER_LENGTH:
            return {
                ...state,
                nAllSingleScripOrdersLength: actions.payload
            };
        case ORDERS.GET_ALL_EQUITY_SIP_SCRIP_ORDER_LENGTH:
            return {
                ...state,
                objEquitySIPMetaData: actions.payload
            };
        case ORDERS.GET_OPEN_SINGLE_SCRIP_ORDER_LENGTH:
            return {
                ...state,
                nOpenSingleScripOrdersLength: actions.payload
            };
        case ORDERS.GET_COMPLETED_SINGLE_SCRIP_ORDER_LENGTH:
            return {
                ...state,
                nCompletedSingleScripOrdersLength: actions.payload
            };
        //Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
        //update
        case ORDERS.SPREAD_ORDERS_LOADING:
            return {
                ...state,
                spreadLoader: actions.payload
            };
        case ORDERS.UPDATE_SPREAD_ALL_ORDERS:
            return {
                ...state,
                arrSpreadAllOrders: [...state?.arrSpreadAllOrders, ...actions.payload]
            };
        case ORDERS.UPDATE_SPREAD_OPEN_ORDERS:
            return {
                ...state,
                arrSpreadOpenOrders: [...state?.arrSpreadOpenOrders, ...actions.payload]
            };
        case ORDERS.UPDATE_SPREAD_COMPLETED_ORDERS:
            return {
                ...state,
                arrSpreadCompletedOrders: [...state?.arrSpreadCompletedOrders, ...actions.payload]
            };
        //length
        case ORDERS.GET_ALL_SPREAD_ORDER_LENGTH:
            return {
                ...state,
                nAllSpreadOrdersLength: actions.payload
            };
        case ORDERS.GET_OPEN_SPREAD_ORDER_LENGTH:
            return {
                ...state,
                nOpenSpreadOrdersLength: actions.payload
            };
        case ORDERS.GET_COMPLETED_SPREAD_ORDER_LENGTH:
            return {
                ...state,
                nCompletedSpreadOrdersLength: actions.payload
            };
        //simple
        case ORDERS.GET_ALL_SPREAD_ORDERS_SUCCESS:
            return {
                ...state,
                arrSpreadAllOrders: actions.payload
            };
        case ORDERS.GET_ALL_SPREAD_ORDERS_FAILURE:
            return {
                ...state,
                arrSpreadAllOrders: actions.payload
            };
        case ORDERS.GET_COMPLETED_SPREAD_ORDERS_SUCCESS:
            return {
                ...state,
                arrSpreadCompletedOrders: actions.payload
            };
        case ORDERS.GET_COMPLETED_SPREAD_ORDERS_FAILURE:
            return {
                ...state,
                arrSpreadCompletedOrders: actions.payload
            };
        case ORDERS.GET_OPEN_ORDERS_SPREAD_SUCCESS:
            return {
                ...state,
                arrSpreadOpenOrders: actions.payload
            };
        case ORDERS.GET_OPEN_ORDERS_SPREAD_FAILURE:
            return {
                ...state,
                arrSpreadOpenOrders: actions.payload
            };
        // Azeem K : 20-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
        case ORDERS.GET_ALL_SIP_ORDERS_SUCCESS:
            return {
                ...state,
                arrAllSipOrders: actions.payload
            };
        case ORDERS.GET_ALL_SIP_ORDERS_FAILURE:
            return {
                ...state,
                arrAllSipOrders: actions.payload
            };
        case ORDERS.GET_COMPLETED_SIP_ORDERS_FAILURE:
            return {
                ...state,
                arrCompletedSipOrders: actions.payload
            };
        case ORDERS.GET_COMPLETED_SIP_ORDERS_SUCCESS:
            return {
                ...state,
                arrCompletedSipOrders: actions.payload
            };
        case ORDERS.GET_OPEN_SIP_ORDERS_SUCCESS:
            return {
                ...state,
                arrOpenSipOrders: actions.payload
            };
        case ORDERS.GET_OPEN_SIP_ORDERS_FAILURE:
            return {
                ...state,
                arrOpenSipOrders: actions.payload
            };
        case ORDERS.UPDATE_ALL_SIP_ORDERS:
            return {
                ...state,
                arrAllSipOrders: actions.payload
            };
        case ORDERS.UPDATE_OPEN_SIP_ORDERS:
            return {
                ...state,
                arrOpenSipOrders: actions.payload
            };
        case ORDERS.UPDATE_COMPLETED_SIP_ORDERS:
            return {
                ...state,
                arrCompletedSipOrders: actions.payload
            };
        case ORDERS.SET_CURRENT_PAGE:
            return {
                ...state,
                nCurrentPage: actions.payload
            };
        // Azeem K : 20-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End
        case ORDERS.SET_FILTER:
            return {
                ...state,
                objFilterData: actions.payload
            };
        // Azeem K : 22-02-2024 : BT-102298   BSEEQ OrderBook – Start 
        case ORDERS.ORDERS_API_PENDING:
            return {
                ...state,
                bIsOrderApiPending: actions.payload
            };
        // Azeem K : 22-02-2024 : BT-102298   BSEEQ OrderBook – End 
        case ORDERS.SIDE_TRAY_ORDERS_API_PENDING:
            return {
                ...state,
                bIsSideTrayOrderApiPending: actions.payload
            };
        //Azeem K : 06-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - All segments - Start
        case ORDERS.IS_MULTIPLE_ORDERS_CANCEL_INPROCESS:
            return {
                ...state,
                bIsMultipleOrdersCancelinProcess: actions.payload
            };
        //Azeem K : 06-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - All segments - End
        //Azeem K : 26-03-2024 : BT-102298 - Breeze - Single Scrip Order entry -Loader added on order entry - Start
        case ORDERS.ORDERS_ENTRY_API_PENDING:
            return {
                ...state,
                bIsOrderEntryApiPending: actions.payload
            };
        //Azeem K : 26-03-2024 : BT-102298 - Breeze - Single Scrip Order entry -Loader added on order entry - End
        // Ajitesh 15-07-2024 Multileg pagination start
        case ORDERS.MULTILEG_ORDERS_LOADING:
            return {
                ...state,
                multilegLoader: actions.payload
            };
        case ORDERS.UPDATE_MULTILEG_ALL_ORDERS:
            return {
                ...state,
                arrMultilegAllOrders: [...state?.arrMultilegAllOrders, ...actions.payload]
            };
        case ORDERS.UPDATE_MULTILEG_OPEN_ORDERS:
            return {
                ...state,
                arrMultilegOpenOrders: [...state?.arrMultilegOpenOrders, ...actions.payload]
            };
        case ORDERS.UPDATE_MULTILEG_COMPLETED_ORDERS:
            return {
                ...state,
                arrMultilegCompletedOrders: [...state.arrMultilegCompletedOrders, ...actions.payload]
            };
        // length
        case ORDERS.GET_ALL_MULTILEG_ORDER_LENGTH:
            return {
                ...state,
                nAllMultilegOrdersLength: actions.payload
            };
        case ORDERS.GET_OPEN_MULTILEG_ORDER_LENGTH:
            return {
                ...state,
                nOpenMultilegOrdersLength: actions.payload
            };
        case ORDERS.GET_COMPLETED_MULTILEG_ORDER_LENGTH:
            return {
                ...state,
                nCompletedMultilegOrdersLength: actions.payload
            };
        // success failure
        case ORDERS.GET_ALL_MULTILEG_ORDERS_SUCCESS:
            return {
                ...state,
                arrMultilegAllOrders: actions.payload
            };
        case ORDERS.GET_ALL_MULTILEG_ORDERS_FAILURE:
            return {
                ...state,
                arrMultilegAllOrders: actions.payload
            };
        case ORDERS.GET_COMPLETED_MULTILEG_ORDERS_SUCCESS:
            return {
                ...state,
                arrMultilegCompletedOrders: actions.payload
            };
        case ORDERS.GET_COMPLETED_MULTILEG_ORDERS_FAILURE:
            return {
                ...state,
                arrMultilegCompletedOrders: actions.payload
            };
        case ORDERS.GET_OPEN_ORDERS_MULTILEG_SUCCESS:
            return {
                ...state,
                arrMultilegOpenOrders: actions.payload
            };
        case ORDERS.GET_OPEN_ORDERS_MULTILEG_FAILURE:
            return {
                ...state,
                arrMultilegOpenOrders: actions.payload
            };
        // Ajitesh 15-07-2024 Multileg pagination end
        case ORDERS.SHOW_SIDETRAY_PLACE_ORDER:
            return {
                ...state,
                bIsShowSideTrayPlaceOrder: actions.payload
            };
        case ORDERS.SHOW_SIDETRAY_CONIRMATION_ORDER:
            return {
                ...state,
                bIsShowSideTrayOrderConfirmation: actions.payload
            };
        case ORDERS.SHOW_SIDETRAY_ORDER_STATUS:
            return {
                ...state,
                bIsShowSideTrayOrderStatus: actions.payload
            };
        //BREEZE-16 : Order Slicing Feature : ManasaB : 22-11-2024 : Placing Order for Squareoff issue - Start
        case ORDERS.UPDATE_ORDER_SLICE_REQUEST_DATA:
            return {
                ...state,
                arrSlicedRequestData: actions.payload
            };
        //BREEZE-16 : Order Slicing Feature : ManasaB : 22-11-2024 : Placing Order for Squareoff issue - End
        case ORDERS.GET_GTD_META_DATA:
            return {
                ...state,
                objGTDMetaData: actions.payload
            };
        case ORDERS.GET_EQSIP_SCRIP_MASTER_SUCCESS:
            return {
                ...state,
                objEqSIPScripMaster: actions.payload
            };
        case ORDERS.GET_EQSIP_SCRIP_MASTER_FAILURE:
            return {
                ...state,
                objEqSIPScripMaster: actions.payload
            };
        //  Azeem K : 15-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - Start 
        case ORDERS.UPDATE_EXIT_ORDER_DATA:
            return {
                ...state,
                objExitOrderData: actions.payload
            };
            //  Azeem K : 15-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - End
            {/* BREEZE-9316: Margin Shortfall: Ravi R: 11-07-2025: Shortfall amount: Start */ }
        case ORDERS.UPDATE_SHORTFALL_AMOUNT:
            return {
                ...state,
                objShortfall: actions.payload
            };
            {/* BREEZE-9316: Margin Shortfall: Ravi R: 11-07-2025: Shortfall amount: End */ }
        default:
            return state;
    }

};

export default ordersReducer;

